<template>
  <a-modal title="设置图片定位"  @ok="submit" v-model:open="opend" width="1200px" :destroyOnClose="true">
    <div class="mover-container" ref="container" v-if="dataSource">
        <img @load="loaded" :src="addip(dataSource.pic)" style="width: 100%;height: auto;" />
        <template v-if="ready">
        <div :style="{left:getwidth(item.x)+'px',top:getheight(item.y,i)+'px'}" class="mover"  v-for="(item,i) in dataSource.children" :key="i"  @mousedown="startDrag(item, $event)">
          <div class="shi"></div>
            {{ item.name }}
        </div>
        </template>
    </div>
  </a-modal>

</template>
<script setup lang="ts">
import {addip} from '@/utils/util'
import {ref,defineProps,onMounted,defineExpose,onUpdated} from 'vue'
  const props= defineProps({
    data:Object
  })
  const emit=defineEmits('change')
  const dataSource=ref<object>({})
  const container=ref()
  let width=0
  let height=0
  const ready=ref<boolean>(false)
  onUpdated(()=>{
    if(props.data){
      dataSource.value=props.data
    }
  })
  const opend=ref<boolean>(false)
  const getwidth=(x)=>{
    if(x){
      return width*x
    }else{
      return 0
    }
  }
  const getheight=(y,i)=>{
    if(y){
      return height*y
    }else{
      return i*50
    }
  }
  const startDrag=(item, event)=> {
    event.preventDefault()
      let t=event.target
      const offsetX = event.clientX - event.target.offsetLeft;
      const offsetY = event.clientY - event.target.offsetTop;
      const  move=(event)=> {
        event.preventDefault()

          let x=event.clientX - offsetX;
          let y=event.clientY - offsetY;

          item.x=x/width
          item.y=y/height
          t.style.left=x
          t.style.top=y
      }
      const stopDragging=()=> {
        document.removeEventListener('mousemove', move);
        document.removeEventListener('mouseup', stopDragging);
      }
      document.addEventListener('mousemove', move);
      document.addEventListener('mouseup', stopDragging);
    }
  const submit=()=>{
      emit('change',dataSource.value)
      close()
  }
  const loaded=()=>{
    if(container.value){
      width=container.value.offsetWidth
      height=container.value.offsetHeight
    }
    ready.value=true
  }
  const open=()=>{
    opend.value=true

  }
  const close=()=>{
    opend.value=false
  }
  defineExpose({open,close})
</script>
<style>
  .mover-container{
width: 100%;height:auto;position: relative;max-height:800px;overflow-y: auto;
  }
  .mover{
    position: absolute;cursor: pointer;
    padding:10px;border:1px solid rgba(255,255,255,.25);color: white;background: rgba(0,0,0,.4);top:10%;left:50%;z-index:10;
  }
  .mover .shi{position: absolute;left:-1px;top:-1px;width:20px;height:20px;
  border-left: 1px solid #fff;border-top: 1px solid #fff;}
</style>
